export default {
    sheetname: 'Valuation data',
    filename: 'Trendmanager_Trendradar-Data_{radarTitle}_{date}'
}
